// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gestion-comptes-prestataires {
  width: 100%;
}

.header-actions {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: #f0f0f0;
}

.close-button svg {
  width: 20px;
  height: 20px;
  fill: #666;
}

.modal-body {
  margin-bottom: 1.5rem;
}

.modal-body p {
  margin: 1rem 0;
  line-height: 1.6;
  color: #555;
}

.form-group {
  margin-bottom: 1.6rem;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 1.2rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  font-family: inherit;
  color: #2c3948;
  line-height: 1.5;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  box-sizing: border-box;
  background: white;
}

.form-group select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.2rem center;
  background-size: 16px 16px;
  padding-right: 3.6rem;
  cursor: pointer;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #f97316;
}

.form-group input.input-error {
  border-color: #dc3545;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.required-star {
  color: #ef4444;
}

.form-group select.input-error {
  border-color: #dc3545;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  border-top: 1px solid #e0e0e0;
  padding-top: 1rem;
}

.modal-secondary-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 2rem;
  border-top: 1px solid #e0e0e0;
}

.modal-secondary-title {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4rem;
  font-weight: 500;
  color: #374151;
  text-align: left;
}

.modal-secondary-buttons {
  display: flex;
  gap: 0.75rem;
}

.user-name,
.user-email,
.user-phone,
.user-fonction,
.creation-date {
  padding: 0.5rem 0;
}

.loading-indicator {
  text-align: center;
  padding: 2rem;
  color: #666;
}

/* ═══════════════════════════════════════════════════════════════════
   Vue cartes — Membres de l'équipe (MEMBRES_VIEW_MODE = 'cards')
   ═══════════════════════════════════════════════════════════════════ */

/* ── Grille ────────────────────────────────────────────────────────── */
.membres-cards-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.4rem;
  padding: 0.5rem 0 1rem;
}

@media screen and (min-width: 1600px) {
  .membres-cards-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media screen and (max-width: 1100px) {
  .membres-cards-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .membres-cards-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 480px) {
  .membres-cards-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Carte ─────────────────────────────────────────────────────────── */
.membre-card {
  background: #fff;
  border-radius: 12px;
  overflow: visible;
  position: relative;
  min-width: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  transition:
    box-shadow 0.2s,
    transform 0.2s;
  cursor: default;
}

.membre-card--editable {
  cursor: pointer;
}

.membre-card--editable:hover {
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transform: translateY(-2px);
}

/* Wrapper interne (comme prestataire-card-inner) */
.membre-card-inner {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border-radius: inherit;
  overflow: hidden;
  position: relative;
}

/* ── Bandeau gris ──────────────────────────────────────────────────── */
.membre-card-header {
  height: 72px;
  border-radius: 12px 12px 0 0;
  position: relative;
  overflow: visible;
}

.membre-card-banner {
  width: 100%;
  height: 72px;
  background: #e5e7eb;
  border-radius: 12px 12px 0 0;
}

/* ── Badge rôle top-right ──────────────────────────────────────────── */
.membre-card-role-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  padding: 0.25rem 0.6rem;
  border-radius: 20px;
  font-size: 1rem;
  font-weight: 700;
  background: rgba(107, 114, 128, 0.88);
  color: #fff;
  z-index: 2;
  white-space: nowrap;
  max-width: calc(100% - 1rem);
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
}

.membre-card-role-badge--admin {
  background: #f97316;
  box-shadow: 0 1px 4px rgba(249, 115, 22, 0.35);
}

/* Couleurs alignees sur l'annuaire : signataires/admin = orange (titulaire),
   simples = gris (prestataire libre). Bandeau + pastille. Ombre SOMBRE (comme l'annuaire)
   pour que la pastille ne se fonde pas dans un bandeau de la meme couleur. */
.membre-card--titulaire .membre-card-banner {
  background: #f97316;
}
.membre-card--titulaire .membre-card-role-badge {
  background: #f97316;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}
.membre-card--libre .membre-card-banner {
  background: #d1d5db;
}
.membre-card--libre .membre-card-role-badge {
  background: #d1d5db;
  color: #374151;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

/* ── Avatar rond chevauchant le bandeau ─── */
.membre-card-avatar-wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30px;
  width: 64px;
  height: 64px;
  background: #fff;
  border-radius: 50%;
  border: 1.5px solid #d1d5db;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1;
  overflow: hidden;
}

.membre-card-avatar {
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.05em;
}

/* ── Corps ─────────────────────────────────────────────────────────── */
.membre-card-body {
  padding: 4rem 1.2rem 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  flex: 1 1;
  text-align: center;
}

.membre-card-name {
  font-weight: 700;
  font-size: 1.35rem;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

.membre-card-fonction {
  font-size: 1.25rem;
  color: #374151;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
}

/* ── Contacts ──────────────────────────────────────────────────────── */
.membre-card-contacts {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  margin-top: 0.5rem;
  width: 100%;
}

.membre-card-contact {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.membre-card-email {
  font-size: 1.2rem;
}

/* ── Message Centralis ─────────────────────────────────────────────── */
.membre-card-hint {
  font-size: 1.05rem;
  color: #9ca3af;
  font-style: italic;
  margin: 0.6rem 0 0;
  text-align: center;
}

/* ── Footer MDP ────────────────────────────────────────────────────── */
.membre-card-footer {
  border-top: 1px solid #f3f4f6;
  padding: 0.65rem 1rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.membre-card-date {
  font-size: 1rem;
  color: #9ca3af;
  font-style: italic;
}

.membre-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 1rem;
  border-radius: 20px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #6b7280;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
}

.membre-card-btn:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.membre-card-btn svg {
  width: 13px;
  height: 13px;
}

/* ── État vide ─────────────────────────────────────────────────────── */
.membres-cards-empty {
  text-align: center;
  color: #9ca3af;
  font-style: italic;
  font-size: 1.3rem;
  padding: 3rem 0;
}

/* ── Skeleton ──────────────────────────────────────────────────────── */
@keyframes membre-shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.membre-card-skeleton {
  pointer-events: none;
}

.membre-card-skeleton .sk {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: membre-shimmer 1.4s ease-in-out infinite;
  border-radius: 4px;
  display: block;
}

.membre-card-skeleton .sk-banner {
  border-radius: 12px 12px 0 0;
  height: 72px;
}

.membre-card-skeleton .sk-badge {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 70px;
  height: 18px;
  border-radius: 20px;
  z-index: 2;
  background: linear-gradient(90deg, #d1d5db 25%, #e5e7eb 50%, #d1d5db 75%);
  background-size: 200% 100%;
  animation: membre-shimmer 1.4s ease-in-out infinite;
  display: block;
}

.membre-card-skeleton .sk-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}

.membre-card-skeleton .sk-line {
  height: 11px;
  margin: 0 auto;
}

.membre-card-skeleton .sk-line--name {
  width: 72%;
  margin-bottom: 4px;
}

.membre-card-skeleton .sk-line--fonction {
  width: 52%;
  margin-bottom: 6px;
}

.membre-card-skeleton .sk-line--contact {
  width: 85%;
  margin-bottom: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/composants/GestionComptesPrestataires/GestionComptesPrestataires.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB;;mBAEiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAAiS;EACjS,4BAA4B;EAC5B,wCAAwC;EACxC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;;wEAEwE;;AAExE,yEAAyE;AACzE;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB;;kBAEgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;;6EAE6E;AAC7E;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf;;sBAEoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,mDAAmD;EACnD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,yEAAyE;EACzE,0BAA0B;EAC1B,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[".gestion-comptes-prestataires {\n  width: 100%;\n}\n\n.header-actions {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.actions-cell {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid #e0e0e0;\n  padding-bottom: 1rem;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.close-button:hover {\n  background-color: #f0f0f0;\n}\n\n.close-button svg {\n  width: 20px;\n  height: 20px;\n  fill: #666;\n}\n\n.modal-body {\n  margin-bottom: 1.5rem;\n}\n\n.modal-body p {\n  margin: 1rem 0;\n  line-height: 1.6;\n  color: #555;\n}\n\n.form-group {\n  margin-bottom: 1.6rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 1.2rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  font-size: 1.6rem;\n  font-family: inherit;\n  color: #2c3948;\n  line-height: 1.5;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  box-sizing: border-box;\n  background: white;\n}\n\n.form-group select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.2rem center;\n  background-size: 16px 16px;\n  padding-right: 3.6rem;\n  cursor: pointer;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #f97316;\n}\n\n.form-group input.input-error {\n  border-color: #dc3545;\n}\n\n.error-message {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n.required-star {\n  color: #ef4444;\n}\n\n.form-group select.input-error {\n  border-color: #dc3545;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n}\n\n.modal-secondary-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 2rem;\n  border-top: 1px solid #e0e0e0;\n}\n\n.modal-secondary-title {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1.4rem;\n  font-weight: 500;\n  color: #374151;\n  text-align: left;\n}\n\n.modal-secondary-buttons {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.user-name,\n.user-email,\n.user-phone,\n.user-fonction,\n.creation-date {\n  padding: 0.5rem 0;\n}\n\n.loading-indicator {\n  text-align: center;\n  padding: 2rem;\n  color: #666;\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   Vue cartes — Membres de l'équipe (MEMBRES_VIEW_MODE = 'cards')\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ── Grille ────────────────────────────────────────────────────────── */\n.membres-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.4rem;\n  padding: 0.5rem 0 1rem;\n}\n\n@media screen and (min-width: 1600px) {\n  .membres-cards-grid {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n@media screen and (max-width: 1100px) {\n  .membres-cards-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media screen and (max-width: 768px) {\n  .membres-cards-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media screen and (max-width: 480px) {\n  .membres-cards-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Carte ─────────────────────────────────────────────────────────── */\n.membre-card {\n  background: #fff;\n  border-radius: 12px;\n  overflow: visible;\n  position: relative;\n  min-width: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  transition:\n    box-shadow 0.2s,\n    transform 0.2s;\n  cursor: default;\n}\n\n.membre-card--editable {\n  cursor: pointer;\n}\n\n.membre-card--editable:hover {\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);\n  transform: translateY(-2px);\n}\n\n/* Wrapper interne (comme prestataire-card-inner) */\n.membre-card-inner {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border-radius: inherit;\n  overflow: hidden;\n  position: relative;\n}\n\n/* ── Bandeau gris ──────────────────────────────────────────────────── */\n.membre-card-header {\n  height: 72px;\n  border-radius: 12px 12px 0 0;\n  position: relative;\n  overflow: visible;\n}\n\n.membre-card-banner {\n  width: 100%;\n  height: 72px;\n  background: #e5e7eb;\n  border-radius: 12px 12px 0 0;\n}\n\n/* ── Badge rôle top-right ──────────────────────────────────────────── */\n.membre-card-role-badge {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  padding: 0.25rem 0.6rem;\n  border-radius: 20px;\n  font-size: 1rem;\n  font-weight: 700;\n  background: rgba(107, 114, 128, 0.88);\n  color: #fff;\n  z-index: 2;\n  white-space: nowrap;\n  max-width: calc(100% - 1rem);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);\n}\n\n.membre-card-role-badge--admin {\n  background: #f97316;\n  box-shadow: 0 1px 4px rgba(249, 115, 22, 0.35);\n}\n\n/* Couleurs alignees sur l'annuaire : signataires/admin = orange (titulaire),\n   simples = gris (prestataire libre). Bandeau + pastille. Ombre SOMBRE (comme l'annuaire)\n   pour que la pastille ne se fonde pas dans un bandeau de la meme couleur. */\n.membre-card--titulaire .membre-card-banner {\n  background: #f97316;\n}\n.membre-card--titulaire .membre-card-role-badge {\n  background: #f97316;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n.membre-card--libre .membre-card-banner {\n  background: #d1d5db;\n}\n.membre-card--libre .membre-card-role-badge {\n  background: #d1d5db;\n  color: #374151;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n}\n\n/* ── Avatar rond chevauchant le bandeau ─── */\n.membre-card-avatar-wrapper {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 30px;\n  width: 64px;\n  height: 64px;\n  background: #fff;\n  border-radius: 50%;\n  border: 1.5px solid #d1d5db;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1;\n  overflow: hidden;\n}\n\n.membre-card-avatar {\n  width: 100%;\n  height: 100%;\n  background: #f3f4f6;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #6b7280;\n  letter-spacing: 0.05em;\n}\n\n/* ── Corps ─────────────────────────────────────────────────────────── */\n.membre-card-body {\n  padding: 4rem 1.2rem 1.4rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  flex: 1;\n  text-align: center;\n}\n\n.membre-card-name {\n  font-weight: 700;\n  font-size: 1.35rem;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  margin: 0;\n}\n\n.membre-card-fonction {\n  font-size: 1.25rem;\n  color: #374151;\n  font-style: normal;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  margin: 0;\n}\n\n/* ── Contacts ──────────────────────────────────────────────────────── */\n.membre-card-contacts {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.1rem;\n  margin-top: 0.5rem;\n  width: 100%;\n}\n\n.membre-card-contact {\n  font-size: 1.2rem;\n  color: #6b7280;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.membre-card-email {\n  font-size: 1.2rem;\n}\n\n/* ── Message Centralis ─────────────────────────────────────────────── */\n.membre-card-hint {\n  font-size: 1.05rem;\n  color: #9ca3af;\n  font-style: italic;\n  margin: 0.6rem 0 0;\n  text-align: center;\n}\n\n/* ── Footer MDP ────────────────────────────────────────────────────── */\n.membre-card-footer {\n  border-top: 1px solid #f3f4f6;\n  padding: 0.65rem 1rem;\n  min-height: 4rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.membre-card-date {\n  font-size: 1rem;\n  color: #9ca3af;\n  font-style: italic;\n}\n\n.membre-card-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 1rem;\n  border-radius: 20px;\n  border: 1px solid #e5e7eb;\n  background: #f9fafb;\n  color: #6b7280;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.15s,\n    border-color 0.15s;\n}\n\n.membre-card-btn:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.membre-card-btn svg {\n  width: 13px;\n  height: 13px;\n}\n\n/* ── État vide ─────────────────────────────────────────────────────── */\n.membres-cards-empty {\n  text-align: center;\n  color: #9ca3af;\n  font-style: italic;\n  font-size: 1.3rem;\n  padding: 3rem 0;\n}\n\n/* ── Skeleton ──────────────────────────────────────────────────────── */\n@keyframes membre-shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n.membre-card-skeleton {\n  pointer-events: none;\n}\n\n.membre-card-skeleton .sk {\n  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);\n  background-size: 200% 100%;\n  animation: membre-shimmer 1.4s ease-in-out infinite;\n  border-radius: 4px;\n  display: block;\n}\n\n.membre-card-skeleton .sk-banner {\n  border-radius: 12px 12px 0 0;\n  height: 72px;\n}\n\n.membre-card-skeleton .sk-badge {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  width: 70px;\n  height: 18px;\n  border-radius: 20px;\n  z-index: 2;\n  background: linear-gradient(90deg, #d1d5db 25%, #e5e7eb 50%, #d1d5db 75%);\n  background-size: 200% 100%;\n  animation: membre-shimmer 1.4s ease-in-out infinite;\n  display: block;\n}\n\n.membre-card-skeleton .sk-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n}\n\n.membre-card-skeleton .sk-line {\n  height: 11px;\n  margin: 0 auto;\n}\n\n.membre-card-skeleton .sk-line--name {\n  width: 72%;\n  margin-bottom: 4px;\n}\n\n.membre-card-skeleton .sk-line--fonction {\n  width: 52%;\n  margin-bottom: 6px;\n}\n\n.membre-card-skeleton .sk-line--contact {\n  width: 85%;\n  margin-bottom: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
